export default __webpack_public_path__ + "static/media/rj45.34bef968.png";